import {
  faCalendarCheck,
  faLightbulb,
  faPeopleGroup,
} from "@fortawesome/free-solid-svg-icons";
import {
  AboutSection,
  AboutSectionCards,
  AboutSectionCardsCard,
  AboutSectionCardsCardIcon,
  AboutSectionCardsCardReadMoreButton,
  AboutSectionCardsCardText,
  AboutSectionCardsCardTitle,
  AboutSectionGradientOverlay,
  AboutSectionImage,
  AboutSectionText,
  AboutSectionTextContainer,
  AboutSectionTextIntroTitle,
  AboutSectionTextTitle,
} from "./AboutExtendedStyles";
import { useEffect } from "react";
import { Link } from "react-router-dom";

function AboutExtended() {
  /**
   * Start card animation only when card is visible
   */
  useEffect(() => {
    const cards = document.querySelectorAll(".home-about-card");

    const onScroll = () => {
      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          card.classList.add("is-visible");
        } else {
          card.classList.remove("is-visible");
        }
      });
    };

    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <>
      <AboutSection>
        <AboutSectionImage src="/assets/5.jpg" alt="Smart Personeel" />
        <AboutSectionGradientOverlay />
        <AboutSectionTextContainer>
          <AboutSectionTextIntroTitle>Wat we doen</AboutSectionTextIntroTitle>
          <AboutSectionTextTitle>
            Better Work, Better Life!
          </AboutSectionTextTitle>
          <AboutSectionText>
            Smart-Personeel biedt slimme oplossingen voor de zorgsector. Met
            jarenlange ervaring en een uitgebreid netwerk van zorgprofessionals
            staan we klaar om de juiste ondersteuning te bieden. Wij zorgen voor
            continuïteit, kwaliteit en flexibiliteit. Samen bouwen we aan een
            efficiënte en toekomstbestendige zorg.
          </AboutSectionText>
        </AboutSectionTextContainer>
      </AboutSection>

      <AboutSectionCards>
        <AboutSectionCardsCard className="home-about-card">
          <AboutSectionCardsCardIcon icon={faLightbulb} size={"3x"} />
          <AboutSectionCardsCardTitle>Smart Flex</AboutSectionCardsCardTitle>
          <AboutSectionCardsCardText>
            Smart Flex levert de juiste zorgprofessionals op locatie, precies
            wanneer en waar ze nodig zijn.
          </AboutSectionCardsCardText>
          <AboutSectionCardsCardReadMoreButton
            as={Link}
            to="/commissioners/flex"
          >
            Lees meer
          </AboutSectionCardsCardReadMoreButton>
        </AboutSectionCardsCard>
        <AboutSectionCardsCard className="home-about-card">
          <AboutSectionCardsCardIcon icon={faPeopleGroup} size={"3x"} />
          <AboutSectionCardsCardTitle>Smart Team</AboutSectionCardsCardTitle>
          <AboutSectionCardsCardText>
            Het Smart Team neemt de regie over een zorglocatie. We leveren een
            team van zorgprofessionals uit verschillende disciplines, afgestemd
            op de specifieke behoeften van de organisatie.
          </AboutSectionCardsCardText>
          <AboutSectionCardsCardReadMoreButton
            as={Link}
            to="/commissioners/crisis"
          >
            Lees meer
          </AboutSectionCardsCardReadMoreButton>
        </AboutSectionCardsCard>
        <AboutSectionCardsCard className="home-about-card">
          <AboutSectionCardsCardIcon icon={faCalendarCheck} size={"3x"} />
          <AboutSectionCardsCardTitle>
            Smart Planners
          </AboutSectionCardsCardTitle>
          <AboutSectionCardsCardText>
            Wat als je zorgplanner tijdelijk uitvalt door ziekte,
            zwangerschapsverlof of ander omstandigheden? Maak je geen zorgen,
            want wij staan voor je klaar!
          </AboutSectionCardsCardText>
          <AboutSectionCardsCardReadMoreButton
            as={Link}
            to="/commissioners/planning"
          >
            Lees meer
          </AboutSectionCardsCardReadMoreButton>
        </AboutSectionCardsCard>
      </AboutSectionCards>
    </>
  );
}

export default AboutExtended;
